"use client";

import { messageToGibberish } from "@faire/localization/core/gibberish";
import type { IStrictTaxonomyLocalMsgProps } from "@faire/localization/core/types";
import { LocalizationStore } from "@faire/localization/deprecated/LocalizationStore";
import { Language } from "@faire/types-localization-api/indigofair/languages/Language";
import React from "react";
import { FormattedMessage } from "react-intl";

// `ILocalMsgProps` and `IStrictTaxonomyLocalMsgProps` are defined in
// `@faire/localization/core/types` so RSC-safe core files can reference them
// without importing from `/react`.
export type {
  ILocalMsgProps,
  IStrictTaxonomyLocalMsgProps,
} from "@faire/localization/core/types";

type FormattedMessageValues = Record<
  string,
  | string
  | number
  | bigint
  | boolean
  | Date
  | React.ReactElement
  | Iterable<React.ReactNode>
  | undefined
>;

export const StrictLocalMsg = <Values,>(
  props: IStrictTaxonomyLocalMsgProps<Values>
) => {
  const { defaultMessage, description, values, id } = props;
  const { localeKey } = LocalizationStore.get();

  if (localeKey?.language === Language.STRING_ID) {
    return <FormattedMessage defaultMessage={id} id={id} />;
  }

  if (localeKey?.language === Language.GIBBERISH) {
    return (
      <FormattedMessage
        defaultMessage={messageToGibberish(defaultMessage)}
        description={description}
        // Any default chunks should be defined using wrappers in the consuming repository
        // this is because updates to defaults need to be included in the eslintrc for that project
        values={values as FormattedMessageValues}
        id={id}
      />
    );
  }

  return (
    <FormattedMessage
      defaultMessage={defaultMessage}
      description={description}
      // Any default chunks should be defined using wrappers in the consuming repository
      // this is because updates to defaults need to be included in the eslintrc for that project
      values={values as FormattedMessageValues}
      id={id}
    />
  );
};
